import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("wcc_token");
    if (!token) { setLoading(false); return; }
    try {
      const me = await authApi.me();
      setUser(me);
    } catch {
      localStorage.removeItem("wcc_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const persist = (data) => {
    localStorage.setItem("wcc_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => persist(await authApi.login({ email, password }));
  const register = async (email, password, display_name) =>
    persist(await authApi.register({ email, password, display_name }));
  const resetPassword = async (email, new_password) =>
    authApi.resetPassword({ email, new_password });
  const testLogin = async () => persist(await authApi.testLogin());
  const logout = () => { localStorage.removeItem("wcc_token"); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, resetPassword, testLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
